/* unplugin-vue-components disabled */import { ElIcon as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/icon/style/css';
import { ElDivider as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/divider/style/css';
import { ElCarousel as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/carousel/style/css';
import { ElCarouselItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/carousel-item/style/css';
import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../assets/img/导航图.png';
import _imports_1 from '../assets/img/image.png';
import _imports_2 from '../assets/img/国际标准.png';
import _imports_3 from '../assets/img/行业权威.png';
import _imports_4 from '../assets/img/高校认可.png';
import _imports_5 from '../assets/img/终身学习.png';
var _hoisted_1 = {
  "class": "banner"
};
var _hoisted_2 = {
  "class": "banner-content"
};
var _hoisted_3 = {
  "class": "content-wrap"
};
var _hoisted_4 = ["href"];
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  "class": "list"
};
var _hoisted_7 = ["onMouseover"];
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  "class": "quicknav"
};
var _hoisted_10 = {
  "class": "itemx"
};
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  "class": "topic"
};
var _hoisted_13 = {
  "class": "topic-content"
};
var _hoisted_14 = ["src"];
var _hoisted_15 = ["onClick"];
var _hoisted_16 = ["textContent"];
var _hoisted_17 = ["textContent"];
var _hoisted_18 = {
  "class": "time"
};
var _hoisted_19 = ["textContent"];
var _hoisted_20 = {
  "class": "partner"
};
var _hoisted_21 = {
  "class": "partner-list"
};
var _hoisted_22 = ["src"];
import router from '@/router';
import { getNewsList, getCarouselList, getCooperateList } from '../api/home/news';
export default /*@__PURE__*/_defineComponent({
  __name: 'HomeViews',
  setup: function setup(__props) {
    var hoverClass = ref(null);
    var list = ref([{
      title: '职场人士',
      src: require('../assets/img/在职人士.png'),
      src2: 'zai_zhi_a.png'
    }, {
      title: '在校学生',
      src: require('../assets/img/在校学生.png'),
      src2: 'xue_sheng_a.png'
    }, {
      title: '企业机构',
      src: require('../assets/img/企业机构.png'),
      src2: 'qi_ye_a.png'
    }, {
      title: '专家顾问',
      src: require('../assets/img/讲师顾问.png'),
      src2: 'jiao_shi_a.png'
    }]);
    //const rz = ref(['CAM认证', 'FCO认证', '活动日历', 'AFA认证', 'CWM认证', 'GAFM资质']);
    var rz = ref([{
      src: require('../assets/img/第一行1.png')
    }, {
      src: require('../assets/img/第一行2.png')
    }, {
      src: require('../assets/img/第一行3.png')
    }, {
      src: require('../assets/img/第二行1.png')
    }, {
      src: require('../assets/img/第二行2.png')
    }, {
      src: require('../assets/img/第二行3.png')
    }]);
    var handleMouseOver = function handleMouseOver(item) {
      hoverClass.value = item;
    };
    var handleMouseOut = function handleMouseOut() {
      hoverClass.value = null;
    };
    var partnerData = ref([]);
    var newsData = ref([{
      name: '',
      context: '',
      pushDate: '',
      image: '',
      id: '',
      intro: '',
      createTime: ''
    }]);
    var carouselData = ref([{
      id: '',
      image: '',
      url: ''
    }]);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var newRes, _newRes$data$records, _newRes$data, carouselRes, _carouselRes$data, cooperateRes, _cooperateRes$data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getNewsList({
              pageNum: 1,
              pageSize: 4
            });
          case 2:
            newRes = _context.sent;
            if (newRes.code === 200) {
              newsData.value = (_newRes$data$records = (_newRes$data = newRes.data) === null || _newRes$data === void 0 ? void 0 : _newRes$data.records) !== null && _newRes$data$records !== void 0 ? _newRes$data$records : [];
            }
            _context.next = 6;
            return getCarouselList();
          case 6:
            carouselRes = _context.sent;
            if (carouselRes.code === 200) {
              carouselData.value = (_carouselRes$data = carouselRes.data) !== null && _carouselRes$data !== void 0 ? _carouselRes$data : [];
              console.log(carouselData.value, 'carouselData.value');
            }
            _context.next = 10;
            return getCooperateList();
          case 10:
            cooperateRes = _context.sent;
            if (cooperateRes.code === 200) {
              partnerData.value = (_cooperateRes$data = cooperateRes.data) !== null && _cooperateRes$data !== void 0 ? _cooperateRes$data : [];
            }
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_el_carousel_item = __unplugin_components_0;
      var _component_el_carousel = __unplugin_components_1;
      var _component_el_divider = __unplugin_components_2;
      var _component_Clock = _resolveComponent("Clock");
      var _component_el_icon = __unplugin_components_3;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_carousel, {
        height: "520px",
        style: {
          "width": "calc(100% - 160px)"
        }
      }, {
        "default": _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(carouselData), function (item) {
            return _openBlock(), _createBlock(_component_el_carousel_item, {
              key: item.id
            }, {
              "default": _withCtx(function () {
                return [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
                  href: item.url,
                  target: "_blank"
                }, [_createElementVNode("img", {
                  src: item.image,
                  alt: ""
                }, null, 8, _hoisted_5)], 8, _hoisted_4)])];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      }), _createElementVNode("ul", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.title,
          "class": _normalizeClass({
            'hover': _unref(hoverClass) == item
          }),
          onMouseover: function onMouseover($event) {
            return handleMouseOver(item);
          },
          onMouseleave: handleMouseOut
        }, [_createElementVNode("img", {
          src: item.src,
          alt: "",
          srcset: "",
          "class": "img_"
        }, null, 8, _hoisted_8), _createElementVNode("p", null, _toDisplayString(item.title), 1)], 42, _hoisted_7);
      }), 128))])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rz), function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.src
        }, [_createElementVNode("img", {
          src: item.src,
          alt: "",
          srcset: ""
        }, null, 8, _hoisted_11)]);
      }), 128))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        "class": "advertising"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        srcset: ""
      })], -1))])]), _createElementVNode("div", _hoisted_12, [_cache[3] || (_cache[3] = _createElementVNode("p", null, "新闻动态", -1)), _createVNode(_component_el_divider, {
        "class": "topic-txt"
      }, {
        "default": _withCtx(function () {
          return _cache[2] || (_cache[2] = [_createTextVNode(" NEWS & EVENTS ")]);
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsData), function (item) {
        return _openBlock(), _createElementBlock("div", {
          "class": "news-grid",
          key: item.id
        }, [_createElementVNode("img", {
          src: item.image,
          alt: "",
          srcset: ""
        }, null, 8, _hoisted_14), _createElementVNode("div", {
          "class": "text",
          onClick: function onClick($event) {
            return _unref(router).push('/broadcastItem/' + item.id);
          }
        }, [_createElementVNode("p", {
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_16), _createElementVNode("p", {
          textContent: _toDisplayString(item.intro)
        }, null, 8, _hoisted_17)], 8, _hoisted_15), _createElementVNode("p", _hoisted_18, [_createVNode(_component_el_icon, null, {
          "default": _withCtx(function () {
            return [_createVNode(_component_Clock)];
          }),
          _: 1
        }), _createElementVNode("span", {
          textContent: _toDisplayString(item.pushDate)
        }, null, 8, _hoisted_19)])]);
      }), 128))]), _createElementVNode("div", {
        "class": "gd",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _unref(router).push('/broadcast');
        })
      }, "查看更多 >>")]), _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"td_bg\" data-v-36aeed4e><div class=\"td_con\" data-v-36aeed4e><dl data-v-36aeed4e><dt data-v-36aeed4e><div class=\"td_bt\" style=\"margin-left:-3px;\" data-v-36aeed4e><span style=\"color:red;font-weight:bold;\" data-v-36aeed4e>CWA精英俱乐部</span><span style=\"font-size:20px;\" data-v-36aeed4e>HIGH QUALITY ACTIVITY PLATFORM </span><p data-v-36aeed4e> Welcome more wealth management practitioners, financial analysts, and investors, entrepreneurs to join the CWA Elite Club. </p><p style=\"display:flex;justify-content:center;align-items:center;\" data-v-36aeed4e>精英俱乐部是由各地投融资分析师、财富规划师，以及财富管理与投融资领域从业者、金融分析师和投资人士、企业家等精英自发组成的志愿性组织，旨在创建积极健康专业的社群环境，提供高质量学习、交流、链接的平台。目前俱乐部拥有成员超过三千名，已经在全国二十多个城市组织活动百余起，涉及私享会、项目路演、精品公开课、高峰财富论坛等内容。欢迎感兴趣的朋友加入我们，在这里您可以找到志同道合的小伙伴，与时间共成长。</p></div></dt><dd data-v-36aeed4e><div class=\"td_name\" data-v-36aeed4e><span data-v-36aeed4e>学习型俱乐部<em data-v-36aeed4e></em></span><p class=\"td_p01\" data-v-36aeed4e>金融从业者, 投资人士, 企业家</p><p class=\"td_p01\" data-v-36aeed4e>联系微信iifachina5申请加入</p><p class=\"td_p03\" data-v-36aeed4e>了解更多</p></div><i data-v-36aeed4e><img src=\"" + _imports_1 + "\" alt=\"乔治·门茨\" title=\"乔治·门茨\" data-v-36aeed4e></i></dd></dl></div></div><div class=\"fw_bg\" data-v-36aeed4e><div class=\"content\" data-v-36aeed4e><div class=\"fw_bt fl\" data-scroll-reveal=\"enter left over 1s and move 100px after 0.3s\" data-v-36aeed4e><b data-v-36aeed4e>IIFA优势</b> <i data-v-36aeed4e>Certification Advantages </i></div><div class=\"fw_con fr\" data-v-36aeed4e><ul data-v-36aeed4e><li data-v-36aeed4e><i data-v-36aeed4e><img src=\"" + _imports_2 + "\" alt=\" \" data-v-36aeed4e></i><span data-v-36aeed4e>International standard<em data-v-36aeed4e> 国际标准</em></span><div class=\"sliphover-container\" data-v-36aeed4e><div class=\"hhover\" data-v-36aeed4e><p class=\"fk_p1\" data-v-36aeed4e>国际标准</p><p class=\"fk_p2\" data-v-36aeed4e>投融资与财富管理领域国际标准推行者，在全球60多个国家或地区拥有会员，备受国际知名金融机构的认可。</p></div></div></li><li data-v-36aeed4e><i data-v-36aeed4e><img src=\"" + _imports_3 + "\" alt=\" \" data-v-36aeed4e></i><span data-v-36aeed4e>Industry Authority<em data-v-36aeed4e>行业权威</em></span><div class=\"sliphover-container\" data-v-36aeed4e><div class=\"hhover\" data-v-36aeed4e><p class=\"fk_p1\" data-v-36aeed4e>行业权威</p><p class=\"fk_p2\" data-v-36aeed4e>深耕个人、家庭、企业理财行业，拥有该领域最权威的全球知名专家顾问团，拥有行业最权威的职业认证标准。</p></div></div></li><li data-v-36aeed4e><i data-v-36aeed4e><img src=\"" + _imports_4 + "\" alt=\" \" data-v-36aeed4e></i><span data-v-36aeed4e>University recognition <em data-v-36aeed4e>高校认可</em></span><div class=\"sliphover-container\" data-v-36aeed4e><div class=\"hhover\" data-v-36aeed4e><p class=\"fk_p1\" data-v-36aeed4e>高校认可</p><p class=\"fk_p2\" data-v-36aeed4e>与全球100多所高等院校和教育机构开展合作与交流，服务涉及实务培训、职业指导、就业推荐、课题研究等。</p></div></div></li><li class=\"nobor\" data-v-36aeed4e><i data-v-36aeed4e><img src=\"" + _imports_5 + "\" alt=\" \" data-v-36aeed4e></i><span data-v-36aeed4e>Lifelong learning <em data-v-36aeed4e>终身学习</em></span><div class=\"sliphover-container\" data-v-36aeed4e><div class=\"hhover\" data-v-36aeed4e><p class=\"fk_p1\" data-v-36aeed4e>终身学习</p><p class=\"fk_p2\" data-v-36aeed4e>针对会员构建起终身继续教育培养体系，将长期为会员提供具有国际视野的高质量前沿、专业、实务学习内容。</p></div></div></li></ul></div></div></div>", 2)), _createElementVNode("div", _hoisted_20, [_cache[5] || (_cache[5] = _createElementVNode("p", null, "合作伙伴", -1)), _createVNode(_component_el_divider, {
        "class": "partner-txt"
      }, {
        "default": _withCtx(function () {
          return _cache[4] || (_cache[4] = [_createTextVNode(" DEEP PARTNER ")]);
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(partnerData), function (item) {
        return _openBlock(), _createElementBlock("img", {
          key: item.image,
          src: item.image,
          alt: "",
          srcset: ""
        }, null, 8, _hoisted_22);
      }), 128))])])], 64);
    };
  }
});